import React from 'react'

const MenuIcon16 = ({ className }) => (
  <svg className={className} height='16' width='16'>
    <path
      d='m15 13c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1h-14c-.55228475 0-1-.4477153-1-1s.44771525-1 1-1zm0-6c.5522847 0 1 .44771525 1 1s-.4477153 1-1 1h-14c-.55228475 0-1-.44771525-1-1s.44771525-1 1-1zm0-6c.5522847 0 1 .44771525 1 1s-.4477153 1-1 1h-14c-.55228475 0-1-.44771525-1-1s.44771525-1 1-1z'
      fillRule='evenodd'
    />
  </svg>
)

export default MenuIcon16
